


















import {Component} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import AuthMixin from "@/mixins/auth.mixin";
import {Api} from "shared/api";
import {IBrandManual} from "shared/entities/brand-manual";
import {apiHandler} from "@/services/api-handler";
import PdfDisplay from "@/components/pdf-display.vue";

@Component({
    components: {PdfDisplay}
})
export default class ViewBrandManual extends mixins(AuthMixin) {
    brandSection: IBrandManual|null = null;

    async mounted() {
        this.brandSection = await apiHandler(() => Api.brandManual[this.$route.params.id].Get());
    }
}

